import client from "@/lib/api";

const guessLabel = () => {
  const ua = navigator.userAgent;
  if (/iPhone|iPad/.test(ua)) return "iPhone / iPad";
  if (/Android/.test(ua)) return "Android phone";
  if (/Mac/.test(ua)) return "Mac";
  if (/Windows/.test(ua)) return "Windows PC";
  return "This device";
};

export const passkeysSupported = () => typeof window !== "undefined" && !!window.PublicKeyCredential;

// Prompts for a name, then runs the browser passkey registration. Returns false if the user cancelled the name prompt.
export async function registerPasskey() {
  const label = window.prompt("Name this passkey (e.g. Katrina's iPhone)", guessLabel());
  if (label === null) return false;
  const { startRegistration } = await import("@simplewebauthn/browser");
  const { data: opts } = await client.post("/auth/passkeys/register/options");
  const credential = await startRegistration({ optionsJSON: opts.options });
  await client.post("/auth/passkeys/register/verify", { ceremony: opts.ceremony, credential, label });
  return true;
}

export function passkeyErrorMessage(e, formatApiErrorDetail) {
  if (e?.name === "NotAllowedError" || e?.name === "AbortError") return null;
  if (e?.name === "InvalidStateError") return "This device already has a passkey for your account";
  return formatApiErrorDetail(e?.response?.data?.detail) || "Couldn't add passkey in this browser";
}
